import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'; // Import navigation styles
import 'swiper/css/pagination'; // Import pagination styles
import { Link } from 'react-router-dom';
import apiService, { getImageUrl, formatPrice } from '../../services/api';

// Fallback tours if API fails
const fallbackTours = [
  {
    id: 1,
    title: "Greece Tour Package",
    image: "/assets/img/tour/tour_box_1.jpg",
    rating: 4.8,
    price: 980,
    duration: "7 Days",
    link: "/tour-details",
  },
  {
    id: 2,
    title: "Italy Tour Package",
    image: "/assets/img/tour/tour_box_2.jpg",
    rating: 4.8,
    price: 980,
    duration: "7 Days",
    link: "/tour-details",
  },
  {
    id: 3,
    title: "Dubai Tour Package",
    image: "/assets/img/tour/tour_box_3.jpg",
    rating: 4.8,
    price: 980,
    duration: "7 Days",
    link: "/tour-details",
  },
  {
    id: 4,
    title: "Switzerland Tour",
    image: "/assets/img/tour/tour_box_4.jpg",
    rating: 4.8,
    price: 980,
    duration: "7 Days",
    link: "/tour-details",
  },
];

function TourOne() {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch featured tours from API
  useEffect(() => {
    const fetchFeaturedTours = async () => {
      try {
        setLoading(true);
        console.log('Fetching featured tours...');
        
        // Fetch featured tours using dedicated endpoint
        const response = await apiService.getFeaturedTours();
        console.log('Tours API response:', response);
        
        // Map API data to component format
        const mappedTours = response.results?.map(tour => {
          const mappedTour = {
            id: tour.id,
            title: tour.name,
            image: getImageUrl(tour.main_image) || '/assets/img/tour/tour_box_1.jpg',
            rating: parseFloat(tour.rating) || 0,
            price: parseFloat(tour.price) || 0,
            duration: `${tour.duration_days} Days`,
            link: `/tour/${tour.slug}`,
            description: tour.short_description,
            difficulty: tour.difficulty_level,
            tour_type: tour.tour_type
          };
          console.log('Mapped tour:', mappedTour);
          return mappedTour;
        }) || [];
        
        console.log('All featured tours loaded:', mappedTours);
        setTours(mappedTours);
        setError(null);
        
      } catch (error) {
        console.error('Error fetching featured tours:', error);
        setError(error.message);
        
        // Use fallback data if API fails
        setTours(fallbackTours);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedTours();
  }, []);

  if (loading) {
    return (
      <section
        className="tour-area position-relative bg-top-center overflow-hidden space bg-no-repeat"
        id="service-sec"
        style={{ backgroundImage: 'url(/assets/img/bg/tour_bg_1.jpg)' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="title-area text-center">
                <span className="sub-title">Best Place For You</span>
                <h2 className="sec-title">Loading Popular Tours...</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="tour-area position-relative bg-top-center overflow-hidden space bg-no-repeat"
      id="service-sec"
      style={{ backgroundImage: 'url(/assets/img/bg/tour_bg_1.jpg)' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="title-area text-center">
              <span className="sub-title">Best Place For You</span>
              <h2 className="sec-title">Most Popular Tour</h2>
              <p className="sec-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
          </div>
        </div>
        
        {/* Navigation Arrows */}
        <div className="row">
          <div className="col-12">
            <div className="slider-control">
              <button className="slider-prev" aria-label="Previous slide">
                <i className="fa fa-chevron-left"></i>
              </button>
              <button className="slider-next" aria-label="Next slide">
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
        
        <div className="slider-area tour-slider">
          <Swiper
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            spaceBetween={24}
            grabCursor={true}
            loop={tours.length > 4}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".slider-next",
              prevEl: ".slider-prev",
            }}
            modules={[Navigation, Autoplay]}
            className="swiper th-slider has-shadow"
          >
            {tours.length > 0 ? tours.map((tour) => (
              <SwiperSlide key={tour.id}>
                <div className="tour-box th-ani gsap-cursor">
                  <div className="tour-box_img global-img">
                    <img 
                      src={tour.image} 
                      alt={tour.title}
                      onError={(e) => {
                        e.target.src = '/assets/img/tour/tour_box_1.jpg'; // fallback image
                      }}
                    />
                  </div>
                  <div className="tour-content">
                    <h3 className="box-title">
                      <Link to={tour.link}>{tour.title}</Link>
                    </h3>
                    <div className="tour-rating">
                      <div className="star-rating" role="img" aria-label={`Rated ${tour.rating} out of 5`}>
                        <span style={{ width: `${(tour.rating / 5) * 100}%` }}>
                          Rated <strong className="rating">{tour.rating.toFixed(1)}</strong> out of 5
                        </span>
                      </div>
                      <Link to={tour.link} className="woocommerce-review-link">
                        (<span className="count">{tour.rating.toFixed(1)}</span> Rating)
                      </Link>
                    </div>
                    <h4 className="tour-box_price">
                      <span className="currency">${tour.price.toFixed(0)}</span>/Person
                    </h4>
                    <div className="tour-action">
                      <span>
                        <i className="fa-light fa-clock" />{tour.duration}
                      </span>
                      <Link to={tour.link} className="th-btn style4 th-icon">
                        Book Now
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            )) : (
              <SwiperSlide>
                <div className="tour-box th-ani">
                  <div className="tour-content text-center p-4">
                    <h3>No featured tours available</h3>
                    <p>Please mark some tours as featured in the admin panel.</p>
                  </div>
                </div>
              </SwiperSlide>
            )}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default TourOne;
